import { AkixiEntities } from '../../../NonReact/constants/AkixiEntities'
import { APIPathParams, getAPIBasePath } from '../../../NonReact/constants/ApiConstants'
import { URLConstructor } from '../../../NonReact/utils/URLBuilder'

enum InsightsHubAPIPathParams {
    INSIGHTS = 'insights'
}

export const insightsHubAPI = (telSys: number, parition: number): URLConstructor =>
    getAPIBasePath().appendPathParams(
        APIPathParams.REPORT,
        AkixiEntities.TEL_SYS,
        telSys,
        AkixiEntities.PARTITION,
        parition,
        InsightsHubAPIPathParams.INSIGHTS
    )

export const insightsHubStatus = getAPIBasePath().appendPathParams(
    APIPathParams.REPORT,
    InsightsHubAPIPathParams.INSIGHTS
)
